import { NavigateFunction, useParams } from 'react-router'
import * as Intro from 'src/styles/views/intro'

export const Footer = ({ navigate }: { navigate: NavigateFunction }) => {
  const { pcode } = useParams()
  const isValidAppWebView = () => {
    const userAgent = navigator.userAgent
    if (/PASS/i.test(userAgent)) {
      return true
    } else {
      return false
    }
  }
  const checkOS = () => {
    if (/Android/i.test(navigator.userAgent)) {
      return 'AOS'
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return 'IOS'
    } else {
      return ''
    }
  }
  const openPartnerPage = () => {
    const isWebView = isValidAppWebView()
    const url =
      process.env.NODE_ENV === 'development'
        ? `https://dev-pj.antiscam.co.kr/mkt01/${pcode}`
        : `https://pj.antiscam.co.kr/mkt01/${pcode}`
    const openWebPage = {
      type: 'O',
      url: url,
      headerObj: { title: '스마트피싱보호', closeType: 'B' },
      useHistoryBack: 'N',
      isSkipAuthAlert: 'N',
    }
    if (isWebView) {
      switch (checkOS()) {
        case 'AOS': {
          window.tauthJs['openWebPage'](JSON.stringify(openWebPage))
          break
        }
        case 'IOS': {
          window.webkit.messageHandlers.tauthJs.postMessage({
            method: 'openWebPage',
            args: openWebPage,
          })
          break
        }
        default:
      }
    } else if (!isWebView) {
      handleNavigateToPartnerPage()
    }
  }
  const handleNavigateToPartnerPage = () => {
    navigate(`/mkt01/${pcode}`)
  }
  return (
    <Intro.FooterWrap>
      <Intro.FooterButton onClick={openPartnerPage}>동의하고 시작하기(유료)</Intro.FooterButton>
    </Intro.FooterWrap>
  )
}
